import { useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../create/confirmationModal";
import { deleteExternalContractById } from "../../../../setup/api/services/contract";
import { ReactComponent as DeleteResource } from "../../../../assets/images/svg/deleteResource.svg";
import createStyles from "../../create/header/header.module.scss";
import styles from "../styles.module.scss";

interface IHeaderProps {
  isDirty: boolean;
  /** The draft project to delete when the seller confirms cancelling. */
  discardId?: string;
  onLeave: () => void;
}

/** "Two-party transaction" with a cancel link that asks before discarding the draft. */
const Header = ({ isDirty, discardId, onLeave }: IHeaderProps) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className={styles.header}>
      <div className={styles.headerRow}>
        <h1 className={styles.headerTitle}>{t("lbl_two_party_transaction")}</h1>
        <button
          type="button"
          onClick={() => (isDirty ? setModalOpen(true) : onLeave())}
          className={styles.headerCancel}>
          {t("lbl_cancel")}
        </button>
      </div>
      <ConfirmationModal
        handleClose={() => setModalOpen(false)}
        horizontalButtons
        handleConfirm={async () => {
          setModalOpen(false);
          if (discardId) {
            try {
              await deleteExternalContractById(discardId);
            } catch (error) {
              console.error(error);
            }
          }
          onLeave();
        }}
        modalOpen={modalOpen}
        title={t("lbl_confirm_cancel_create_two_party")}
        description={t("lbl_discarded_changes_gone")}
        icon={<DeleteResource />}
        confirmText={t("lbl_cancel")}
        cancelText={t("lbl_delete_transaction_back_btn")}
        containerStyle={createStyles.modalContainer}
      />
    </div>
  );
};

export default Header;
